import React, { Suspense } from 'react';
import PropTypes from 'prop-types';

import pizzaBoxLoader from '../Spinner/assets/loader_pizzabox_green.svg';
import spinnerStyles from '../Spinner/components/styles.module.scss';

const initialFallback = (
  <div className={`row center middle ${spinnerStyles.spinnerContainer}`}>
    <img src={pizzaBoxLoader} alt="Loading" width="150" height="125" />
  </div>
);

function CustomSuspense({ fallback, children }) {
  return <Suspense fallback={fallback}>{children}</Suspense>;
}

CustomSuspense.defaultProps = {
  fallback: initialFallback
};

CustomSuspense.propTypes = {
  children: PropTypes.node,
  fallback: PropTypes.element
};

export default CustomSuspense;
